import React from "react";
import clsx from "clsx";

const sizes = {
  xs: "w-3 h-3",
  sm: "w-4 h-4",
  md: "w-6 h-6",
  lg: "w-8 h-8",
  xl: "w-12 h-12",
};

const Spinner = ({
  size = "md",
  color = "primary",
  className = "",
  label = "Carregando...",
  showLabel = false,
}) => {
  const colorClasses = {
    primary: "text-primary-500",
    white: "text-white",
    dark: "text-dark-600 dark:text-dark-400",
    inherit: "text-current",
  };

  return (
    <div
      className={clsx("inline-flex items-center gap-2", className)}
      role="status"
      aria-label={label}
    >
      <svg
        className={clsx("animate-spin", sizes[size], colorClasses[color])}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
      {showLabel && (
        <span className="text-sm text-dark-600 dark:text-dark-400">{label}</span>
      )}
    </div>
  );
};

// Full page loading overlay
Spinner.Overlay = ({ label = "Carregando..." }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/80 dark:bg-dark-900/80">
    <div className="flex flex-col items-center gap-3">
      <Spinner size="xl" />
      <span className="text-sm font-medium text-dark-600 dark:text-dark-400">
        {label}
      </span>
    </div>
  </div>
);

// Inline loading for buttons or small areas
Spinner.Inline = ({ size = "sm", className = "" }) => (
  <Spinner size={size} color="inherit" className={className} />
);

export default Spinner;
